module.exports = __webpack_public_path__ + "static/media/DownloadImg.12e70795.svg";